import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { newEmpresa } from "../../model";
import { toast } from "react-toastify";

export class _IntegrationStore {
  obs = observable({
    selectedEmpresa: newEmpresa(),
    open_select_empresa: false,
    select_tab_geral: "tarefas",
    isEmpresa: false,

    tarefas: [],
    tarefas_page: 1,
    tarefas_length: 0,

    envio_automatico_dominio_api: false,
    envio_automatico_questor_api: false,
    envio_automatico_sci_api: false,
    token_cliente_dominio: "",
    token_cliente_sci: ""
  })

  async handleLoadIntegration(cnpj: string) {

    this.obs.envio_automatico_dominio_api = false
    this.obs.envio_automatico_questor_api = false
    this.obs.envio_automatico_sci_api = false
    this.obs.token_cliente_dominio = ""
    this.obs.token_cliente_sci = ""

    try {

      let resp = await apiOperacao("xml_integracao").get(`/xml_integracao/integration/${cnpj}`)

      this.obs.envio_automatico_dominio_api = resp.data.envio_automatico_dominio_api || false
      this.obs.envio_automatico_questor_api = resp.data.envio_automatico_questor_api || false
      this.obs.envio_automatico_sci_api = resp.data.envio_automatico_sci_api || false
      this.obs.token_cliente_dominio = resp.data.token_cliente_dominio || ""
      this.obs.token_cliente_sci = resp.data.token_cliente_sci || ""

    } catch (ex) { }

  }

  async handleSaveToken(params) {

    try {

      let resp = await apiOperacao("xml_integracao").post('/xml_integracao/token', params)

      if (resp.data.ok) {

        toast.success("Configuração salva com sucesso!", {})

        await this.handleLoadIntegration(params.cnpj)

      } else {

        toast.error(resp.data.error, {})

      }

    } catch (ex) { }

  }

  async handleConsultaTarefa(page: number, cnpj: string, tipo: string) {

    try {

      let params = {
        paged: page,
        cnpj: cnpj,
        limit: 20,
        tipo: tipo
      }

      let resp = await apiOperacao("xml_integracao").post('/xml_integracao/index', params)

      this.obs.tarefas = []
      this.obs.tarefas_length = 0

      if (resp.data.itens.length) {

        this.obs.tarefas = resp.data.itens.map(item => ({
          ...item,
          total_notas: item.type_api === "questor" 
            ? (item.total_notas || 0) * 50 
            : item.total_notas || 0
        }));
  
        this.obs.tarefas_length = resp.data.count;

      }

    } catch (ex) { }

  }

  async handleDownloadArquivoIntegration(id: string) {

    try {

      const resp = await apiOperacao("xml_integracao").get(`/xml_integracao/download/${id}`, {responseType: "blob"})

      const url = window.URL.createObjectURL(resp.data)

      const link = document.createElement("a")

      link.href = url
      link.download = `${id}.zip`

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

    } catch (ex) {

      console.error(ex)
      
    }
  }

}

export const IntegrationStore = new _IntegrationStore();